import type { GetProjectComments200PageAllOfThreeContentItem } from './getProjectComments200PageAllOfThreeContentItem';

export type GetProjectComments200PageAllOfThree = {
  /** 프로젝트 댓글 목록 */
  content?: GetProjectComments200PageAllOfThreeContentItem[];
};
